import React from 'react';

import Avatar from './Avatar';

class Participant extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    return (
      <td className="participant">
        <Avatar participant={this.props.participant} />
        <div>{ this.props.participant.me && "You" || this.props.participant.name }</div>
      </td>
    )
  }
}

export default Participant;
